module.exports = __webpack_public_path__ + "media/4-star-wish-reveal-first.bdc77457.ogg";